import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

import { useModal } from '../../../function/useModal';
import { ResponceDataType, ErrorCode } from '../../../ErrorCode';

import MessageDialog, { MessageDialogResponse } from '../../atoms/Dialog/MessageDialog';
import ConfirmDialog, { ConfirmDialogResponse } from '../../atoms/Dialog/ConfirmDialog';
import ItemComboBoxStr, { ComboBoxItemTypeS } from '../../atoms/ComboBox/ItemComboBoxStr';
import SimpleCalender from '../../atoms/Calendar/SimpleCalender';
import DateInput from '../../atoms/Calendar/DateInput';
import { SelectDataType } from './OffLineJudge';
import OffLineJudteFotter from './OffLineJudgeFooter';
import {
  GetOffLineJudgeData,
  OfflineJudgeDataType,
  CreateDevCombBoxItems,
  GetOffLineJudgeFileTimes,
  CreateTimeCombBoxItems,
  ExecuteCopyOffLineJudgeFile,
  GraphDispSetting
} from './OffLineJudge';
import { OffLineJudgeStyle, TableBaseStyle ,OffLineJudgeGraphStyle} from './OffLineJudgeStyle';
import OffLineJudgeChart from './OffLineJudgeChart';
//import { useHistory } from 'react-router-dom';


import RangeInputNumberLimit from '../../molecules/Range/RangeInputNumberLimit';
import RangeInputNumber from '../../molecules/Range/RangeInputNumber';

type OffLineJudgePageProps = {};

const OffLineJudgePage: React.FC<OffLineJudgePageProps> = () => {
  //const history = useHistory();
  const { t } = useTranslation();
  const offLineJudgeStyle = OffLineJudgeStyle();
  const offLineJudgeGraphStyle = OffLineJudgeGraphStyle();
  const tableStyle = TableBaseStyle();

  const [offlineJudgeData, setOfflineJudgeData] = useState<OfflineJudgeDataType[]>([]); //デバイス情報データ
  const [selectDevComboBoxList, setSelectDevComboBoxList] = useState<ComboBoxItemTypeS[]>([]); //デバイスコンボボックス
  const [selectTimeComboBoxList, setSelectTimeComboBoxList] = useState<ComboBoxItemTypeS[]>([]); //時間コンボボックス
  const [buttonEnable, setButtonEnable] = useState<boolean>(true);
  const [dispGlaphFlg,setDispGlaphFlg] = useState<boolean>(false);  //グラフ表示フラグ
  const [chartUpdate, setChartUpdate] = React.useState<string>('');
  
  const [startTime, setstartTime] = useState<string>(' ');
  const [endTime, setendTime] = useState<string>(' ');
  const [selectIndex, setSelectIndex] = useState<number>(1);
  const [saveFlg,setSaveFlg] = useState<boolean>(false);

  const [selectData, setSelectData] = useState<SelectDataType>({
    devIndex: '0',
    selectDate: dayjs(new Date()).format('YYYY-MM-DD'),
    selectTime: '',
  });

  const [loading, setLoading] = React.useState<boolean>(false);
  
  const isAutoRangeRef = React.useRef<boolean>(true);

  //グラフ
  const [graphDispSetting, SetGraphDispSetting] = React.useState<GraphDispSetting>({
    xMin:0,
    xMax:100,
    yMin:-0.2,
    yMax:0.2,
    isPileup:false,
    isDCRemoval:false
  });

  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
  const [dlgmsg, setDlgmsg] = useState<string>('');

  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;
  const cfmdlg = flgCfmDlg ? (
    <ConfirmDialog
      dialog={actCfmDlg}
      message={dlgmsg}
      action={t('OffLineJudgePage.はい', 'はい')}
      cancel={t('OffLineJudgePage.いいえ', 'いいえ')}
    />
  ) : null;

  /**
   * 初期表示
   */
  useEffect(() => {
    upDatePage();
  }, []);

  /**
   * 時間コンボボックス更新
   */
  const upDateSelectTimeList = () => {
    setButtonEnable(false);
    let cmdList: ComboBoxItemTypeS[];
    GetOffLineJudgeFileTimes(selectData.devIndex, selectData.selectDate)
      .then((r: Date[]) => {
        if (r != null && r.length != 0) {
          cmdList = CreateTimeCombBoxItems(r);
        } else {
          cmdList = [];
        }
        if (cmdList.length != 0) {
          selectData.selectTime = cmdList[0].key;
          setSelectData((prev) => ({ ...prev, selectTime: cmdList[0].key }));
        }
        setSelectTimeComboBoxList([...cmdList]);
      })
      .catch((e) => {
        setDlgmsg(t('OffLineJudgePage.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
        actMsgDlg.open();
        console.error(['OffLineJudgePage - useEffect[selectData] - Error', e]);
      })
      .finally(() => {
        setButtonEnable(true);
      });
  };

  /**
   * 画面更新
   */
  const upDatePage = () => {
    let offlineList: OfflineJudgeDataType[] = [];
    let cmdList: ComboBoxItemTypeS[];
    let selectDevIndex = '0';
    let dt = dayjs(new Date()).format('YYYY-MM-DD');

    setButtonEnable(false);
    GetOffLineJudgeData()
      .then((r: OfflineJudgeDataType[]) => {
        offlineList = r;
        if (r.length !== 0) {
          cmdList = CreateDevCombBoxItems(r);
          selectDevIndex = cmdList[0].key;
        }

        console.debug(['OffLineJudgePage useEffect - result , cmdList', r, cmdList]);
        setOfflineJudgeData([...offlineList]);
        setSelectDevComboBoxList([...cmdList]);
        setSelectData({ devIndex: selectDevIndex, selectDate: dt, selectTime: '' });
        selectData.devIndex = selectDevIndex; //初期の時間を取得するのにここでセット
        changeCalendarValueAction(dt);
      })
      .catch((e) => {
        setDlgmsg(t('OffLineJudgePage.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
        actMsgDlg.open();
        console.error(['OffLineJudgePage - upDatePage - Error', e]);
        setSelectData({ devIndex: selectDevIndex, selectDate: dt, selectTime: '' });
        setOfflineJudgeData([]);
        setSelectDevComboBoxList([]);

        throw new Error('Page3Child Throw Error');
      })
      .finally(() => {
        setButtonEnable(true);
      });
  };

  /**
   * 機器選択変更Event
   * @param value
   */
  const onDevIndexSelectDataChange = (e: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const selectDevIndex = String(e.target.value);
    selectData.devIndex = selectDevIndex;
    setstartTime('0');
    setendTime('30000');
    setSaveFlg(false);
    setDispGlaphFlg(false);
    upDateSelectTimeList();
  };
  /**
   * カレンダー値変更
   * @param value
   */
  const changeCalendarValueAction = (value: string) => {
    selectData.selectDate = value;
    selectData.selectTime = '';
    setstartTime('0');
    setendTime('30000');
    setSaveFlg(false);
    upDateSelectTimeList();
  };

  /**
   * 時間変更
   * @param value
   */
  const changeTimeValueAction = (e: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const selectTimeIndex = String(e.target.value);
    setSelectData((prev) => ({ ...prev, selectTime: selectTimeIndex }));
    setstartTime('0');
    setendTime('30000');
    setSaveFlg(false);
  };

  /**
   * 選択ボタンアクション
   */
  const selectAction = () => {
    if (selectData.selectTime === '') {
      setDlgmsg(t('OffLineJudgePage.時刻を設定してください', '時刻を設定してください'));
      actMsgDlg.open();
      return;
    }
    setDlgmsg(t('OffLineJudgePage.選択した内容で、実行しますか?', '選択した内容で、実行しますか?'));
    actCfmDlg
      .open()
      .apply((_) => {
        setButtonEnable(false);
        const devIndex = selectData.devIndex;
        const selectDate = `${selectData.selectDate} ${selectData.selectTime}`;
        ExecuteCopyOffLineJudgeFile(devIndex, selectDate,startTime,endTime,saveFlg)
          .then((r) => {
            if (r.ErrorCode !== ErrorCode.ERR_CODE_NONE) {
              setDlgmsg(
                t(
                  'OffLineJudgePage.オフライン判定実行中にエラーが発生しました',
                  'オフライン判定実行中にエラーが発生しました'
                )
              );
              actMsgDlg.open();
              console.error(r);
            } else {
              setDlgmsg(t('OffLineJudgePage.オフライン判定を開始しました', 'オフライン判定を開始しました'));
              actMsgDlg.open();
            }
          })
          .catch((e) => {
            console.error(e);
            setDlgmsg(t('OffLineJudgePage.オフライン判定を開始しました', 'オフライン判定を開始しました'));
            actMsgDlg.open();
          })
          .finally(() => {
            setButtonEnable(true);
          });
      })
      .cancel(() => {
        console.debug(t('OffLineJudgePage.キャンセル', 'キャンセル'));
      });
  };

  /**
   * 確定・クリアボタンアクション
   */
  const definitionAction = () =>{
    //開始・終了の設定を行わなかった場合
    if (startTime === ' ' || endTime === ' ' || selectData.selectTime === ''){
      setDlgmsg(t('OffLineJudgePage.開始終了時間が登録されていません','開始終了時間が登録されていません'));
      actMsgDlg.open();
      return;
    }
    //選択範囲が開始 <= 終了か確認
    if(Number(startTime) > Number(endTime)){
      setDlgmsg(t('OffLineJudgePage.選択範囲が開始>終了になっています','選択範囲が開始 > 終了になっています'));
      actMsgDlg.open();
      return;
    }

    if(offlineJudgeData[0].AppModeSelect == 1){
      console.debug(['オンプレミスモード:10.5秒チェック 開始、終了',startTime,endTime]);
      if(Number(endTime) - Number(startTime) < 10500){
        setDlgmsg(t('OffLineJudgePage.選択範囲が10.5秒未満になっています','選択範囲が10.5秒未満になっています'));
        actMsgDlg.open();
        return;
      }
    }
    else{
      console.debug(['クラウドモード:13.1秒チェック 開始、終了',startTime,endTime]);
      if(Number(endTime) - Number(startTime) < 13100){
        setDlgmsg(t('OffLineJudgePage.選択範囲が13.1秒未満になっています','選択範囲が13.1秒未満になっています'));
        actMsgDlg.open();
        return;
      }
    }

    //ボタンのモードを確認
    if(saveFlg){
      //クリアモード
      //設定内容のリセット
      setstartTime('0');
      setendTime('30000');
      setSaveFlg(false);
    }
    else{
      //確定モード
      //クリアボタンに変更し、設定した値がグラフをクリックしても書き換わらないようにする
      setSaveFlg(true);
    }
    
  }

  /**
   * 振動軸範囲変更イベント
   * @param min1 
   * @param max1 
   */
  const handleYMinMaxChange = (min1: number, max1: number) => {
    SetGraphDispSetting({ ...graphDispSetting, yMin: min1, yMax: max1});
  };
  
  const handoleAutoRangeSet = (data: boolean) => {
    isAutoRangeRef.current = data;
  };

  const handleLoading = (isFlg: boolean) => {
    setLoading(isFlg);
  };

  const handleGraphSettingChange = (data: GraphDispSetting) => {
      SetGraphDispSetting({ ...data });
  };
  
  /**
   * 時間軸範囲変更イベント
   * @param min 
   * @param max 
   */
  const xMinMaxOn = (min: number, max: number) => {
    console.debug(`min=${min},max=${max}`);
    var tmp = graphDispSetting;
    tmp.xMin = min;
    tmp.xMax = max;
    handleGraphSettingChange(tmp);
  };

  const yMinMaxOn = (min: number, max: number) => {
    console.debug(`min=${min},max=${max}`);
    var tmp = graphDispSetting;
    tmp.yMin = min;
    tmp.yMax = max;

    handleGraphSettingChange(tmp);
  };

   const handleTimeCellClick = (selectIndex: number) => {
    onChangeTimeSelectIndex(selectIndex);
  };

  const onTimeCellDoubleClick = (selectIndex: number) => {
    deleteSelectData(selectIndex);
  };

  /**
   * 時間選択テキストボックス番号変更通知
   * @param index
   */
  const onChangeTimeSelectIndex = (index: number) => {
    console.debug(['-OffLineJudgePage - select TimeTable Change',selectIndex, index]);
    setSelectIndex(index)
  };

  /**
   * 日付選択テキストボック値削除
   * @param index
   */
  const deleteSelectData = (index: number) => {
    if (index == 1) {
      setstartTime(' ');
    } else {
      setendTime(' ');
    } 
  };

  /**
   * 選択した時間の保持する処理
   * @param xValue 
   * @returns 
   */
  const handleGraphClick = (xValue: number) => {
    const formatted = xValue.toFixed(3); 
    
    if (selectIndex !== 1 && selectIndex !== 2) return;

    if (selectIndex === 1 && saveFlg === false) {
      console.debug(['handleGraphClick event1',formatted]);
      setstartTime(formatted);
    } else if (selectIndex === 2 && saveFlg === false) {
      console.debug(['handleGraphClick event2',formatted]);
      setendTime(formatted);
    }
  };


  return (
    <>
    <Grid container spacing={1} alignItems="center">
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 2 }}>
        {/* 機器・計測日テーブル */}
        <Grid item xs={4} md="auto">
          <Paper elevation={3} classes={{ root: offLineJudgeStyle.paperRoot }}>
            <Table aria-label="a main table">
              <TableBody>
                <TableRow>
                  <TableCell className={tableStyle.headerCell} width={100}>
                    {t('OffLineJudgePage.機器', '機器')}
                  </TableCell>
                  <TableCell className={tableStyle.bodyCell}>
                    <ItemComboBoxStr
                      itemList={selectDevComboBoxList}
                      label={''}
                      value={selectData.devIndex}
                      onChangeEvent={onDevIndexSelectDataChange}
                    ></ItemComboBoxStr>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={tableStyle.headerCell}>{t('OffLineJudgePage.計測日', '計測日')}</TableCell>
                  <TableCell className={tableStyle.bodyCell}>
                    <table>
                      <tr>
                        <td>
                          <DateInput
                            initialValue={dayjs(selectData.selectDate).format('YYYY-MM-DD')}
                            label={''}
                            labelPosition={1}
                            onDateChange={changeCalendarValueAction}
                          ></DateInput>
                        </td>
                        <td>
                          <ItemComboBoxStr
                            itemList={selectTimeComboBoxList}
                            label={''}
                            value={selectData.selectTime}
                            onChangeEvent={changeTimeValueAction}
                          ></ItemComboBoxStr>
                        </td>
                      </tr>
                    </table>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Paper>
        </Grid>
        {/**区間選定ボタン */}
        <Grid  item xs={12} md="auto" style={{ marginTop: 65 }}>
          <Button
            variant="contained"
            className={offLineJudgeGraphStyle.buttonStyle}
            color="primary"
            disabled={false}
            disableElevation
            onClick={(e) => {
              
              setDispGlaphFlg(true);
              setChartUpdate(Date.now().toString());
            }}
          >
            {t('OffLineJudgePage.区間選定','区間選定')}
          </Button>
          
      </Grid>
      {/**開始終了 */}
      <Grid  item xs={12} sm={6} md="auto" style={{ marginTop: 55, marginLeft: 10}} >
        <TableBody>
          <TableRow>
            <TableCell
              className={tableStyle.tableNameeCell}
              align="center"
              style={{ minWidth: 80 }}
            >
            {t('OffLineJudgePage.開始', '開始')}
            </TableCell>
            <TableCell
              className={tableStyle.tableNameeCell}
              align="center"
              style={{ minWidth: 80 }}
            >
            {t('OffLineJudgePage.終了', '終了')}
            </TableCell>
          </TableRow>
            <TableRow>
                  <TableCell
                    style={{ minWidth: 80 }}
                    className={selectIndex === 1 ? tableStyle.tableSelectCell : tableStyle.tableCell}
                    onClick={() => handleTimeCellClick(1)}
                    onDoubleClick={(e) => onTimeCellDoubleClick(1)}
                  >
                    {startTime|| '0'}
                  </TableCell>
                  
                  <TableCell
                   style={{ minWidth: 80 }}
                    className={selectIndex === 2 ? tableStyle.tableSelectCell : tableStyle.tableCell}
                    onClick={() => handleTimeCellClick(2)}
                    onDoubleClick={(e) => onTimeCellDoubleClick(2)}                  >
                    {endTime|| '30000'}
                  </TableCell>
                </TableRow>
              </TableBody>
      </Grid>
      {/**確定・クリアボタン */}
      <Grid item xs={6} md="auto" style={{ marginTop: 65, marginLeft: -30}}>
        <Button
          variant="contained"
          className={offLineJudgeGraphStyle.buttonStyle}
          color="primary"
          disabled={false}
          disableElevation
          onClick={(e) => {
            definitionAction();
          }}
        >
          {saveFlg ? t('OffLineJudgePage.クリア','クリア'): t('OffLineJudgePage.確定','確定')}
        </Button>
      </Grid>
      <Grid  item xs={12} md={3}>       
        <Box display="flex" justifyContent="flex-start" alignItems="flex-end" style={{ marginTop: 55 }}>
          <div style={{ width: 310 }}>
           {/**時間軸範囲 */}
            <RangeInputNumberLimit
              textBoxWidth={'70px'}
              limitValue={5000}
              label={t('OffLineJudgePage.時間軸範囲', '時間軸範囲')}
              minValue={graphDispSetting.xMin}
              maxValue={graphDispSetting.xMax}
              minValueLimit={0}
              maxValueLimit={30000}
              onChange={xMinMaxOn}
            />
            {/**振動幅範囲 */}
            <RangeInputNumber
              textBoxWidth={'70px'}
              label={t('OffLineJudgePage.振動幅範囲', '振動幅範囲')}
              minValue={graphDispSetting.yMin}
              maxValue={graphDispSetting.yMax}
              minValueLimit={-999.999}
              maxValueLimit={999.999}
              onChange={(max, min) => yMinMaxOn(max, min)}
            />
          </div>
        </Box>
      </Grid>
      {/**実行ボタン */}
      </Grid>
        <Grid item xs={12} md="auto">
          <OffLineJudteFotter onClickSelectButton={selectAction} buttonEnable={buttonEnable}></OffLineJudteFotter>
        </Grid>
        
      </Grid>
      {/**グラフ表示 */}
      <>
        {dispGlaphFlg == true ? 
         //グラフ表示
         <OffLineJudgeChart
            key={chartUpdate}
            line={selectData}
            graphDispSetting={graphDispSetting}
            isAutoRangeRef={isAutoRangeRef.current}
            OfflineJudgeList={offlineJudgeData}
            update={chartUpdate}
            onLoading ={handleLoading}
            onAutoRangeSet = {handoleAutoRangeSet}
            onChagneYMinMax ={handleYMinMaxChange}
            onGraphClick={handleGraphClick}
         />       
         :null
        }      
      </> 
      {msgdlg}
      {cfmdlg}
    </>
  );
};

export default OffLineJudgePage;
